module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.name, {
    tag: "component"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-89f269b8!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-feather-icon/components/index.vue
// module id = 1505
// module chunks = 39